import './notFoundData.css'

export const NotFoundData = () => {
    return (
        <li className="catalog__not_found">
            <h3>Sorry, no matches found</h3>
            <img src="https://i.gifer.com/7VE.gif" alt="not_found_gif"/>
        </li>
    )
}